import styled from "styled-components"


export const Container = styled.div`
    width: min-content;
    font-size: 13px;
    color: #969696;
    margin: 0 auto;
    margin-top: 70px;
    padding: 20px;

    
    @media (max-width: 1000px) { 
        width: 100%;
        padding: 0;
    }


`;

export const SectionTitle = styled.h1`
    font-size: 25px;
    color: #e0e0e0;
    text-align: center;
    
    @media (max-width: 400px) { 
        font-size: 17px;
    }
`;

export const SectionSubTitle = styled.a`
    display:block;
    text-align: center;
    font-size: 13px;
    color: #BB86FC;
    text-decoration: none;
    max-width: 150px;
    margin: 0 auto;
    margin-bottom: 30px;

    &:hover{
        text-decoration: underline;
    }

`;


export const ProjectListContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;

    @media (max-width: 1200px) { 
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 1000px) { 
        grid-template-columns: repeat(1, 1fr);
    }
`;

// css for otherproject item

export const ItemContainer = styled.div`
    display: flex;
    width: 320px;
    background-color: #161616;
    border-radius: 5px;
    padding: 20px;

    
    @media (max-width: 1000px) { 
        margin: 0 auto;
        width: 400px;
    }
    @media (max-width: 600px) { 
        width: 270px;
    }

    @media (max-width: 380px) { 
        width: 270px;
    }
    
    @media (max-width: 340px) { 
        width: 220px;
    }
`;

export const ItemSnapshotContainer = styled.div`
    width: 130px;
`;

export const ItemSnapshot = styled.img`
    height: 230px;
    vertical-align: middle;
    
    @media (max-width: 1000px) { 
        height: 250px;
    }
    @media (max-width: 600px) { 
        height: 220px;
    }
`;

export const InfoContainer = styled.div`
    text-align: left;
    padding-left: 20px;
`;

export const FeaturedText = styled.p`
    color: #BB86FC;
    font-size: 12px;
`;

export const ItemName = styled.h1`
    font-size: 20px;
    color: #e0e0e0;
    display: inline;
`;

export const DescriptionContainer = styled.div`
    max-width: 200px;

    @media (max-width: 1000px) { 
        max-width: 230px;
    }
    @media (max-width: 600px) { 
        max-width: 190px;
    }
`;

export const DescriptionText = styled.p`
    margin-top: 12px;
    font-size: 13px;

    @media (max-width: 1000px) { 
        font-size: 15px;
    }

    @media (max-width: 600px) { 
        font-size: 13px;
    }
`;


export const Link = styled.a`
    font-size: 20px;
    margin-left: 10px;
    color: #BB86FC;
`;